import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import useHttpHook from "../../Hooks/HttpHook";
import { CancelRemainingEmis } from "../../utils/ApiConstant";
import MainComponentWrapper from "../Common/MainComponentWrapper";

export const CancelEmiModal = ({ orderId, onClose, show }) => {
  const [loading, sendRequest, error] = useHttpHook();
  const handleCancelRemainingEmis = async (orderId) => {
    try {
      let response = await sendRequest(`${CancelRemainingEmis}`, {
        method: "post",
        data: {
          orderId,
        },
      });
      if (response.status === 1) {
        onClose();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <MainComponentWrapper loading={loading} errorInfo={error}>
        <Modal show={show} onHide={onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Cancel Remaining EMIs</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to cancel the remaining EMIs?
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              onClick={() => {
                handleCancelRemainingEmis(orderId);
              }}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      </MainComponentWrapper>
    </>
  );
};
